// Custom styled Button with variants
import { Button, styled } from "@mui/material";
import React from "react";

const DeedButtons = styled(Button)(({ theme, variant }) => ({
    borderRadius: 13,
    padding: `${theme.spacing(2)}`, // Adjust padding for reduced height
    minWidth:170,
    textTransform: "none",
    fontWeight: 700,
    fontSize: "1.1rem",
    letterSpacing: "0.5px",
    transition: "all 0.3s ease",
    ...(variant === "contained" && {
        background: `linear-gradient(135deg, ${theme.palette.primary.main}, #00a0ff)`,
        color: "#FFFFFF",
        boxShadow: "0 8px 20px rgba(10, 118, 250, 0.3)",
        "&:hover": {
            transform: "translateY(-3px)",
            boxShadow: "0 12px 28px rgba(10, 118, 250, 0.4)",
            background: `linear-gradient(135deg, ${theme.palette.primary.dark}, #0090e8)`,
        },
        "&:active": {
            transform: "translateY(0)",
            boxShadow: "0 5px 15px rgba(10, 118, 250, 0.3)",
        },
    }),
    ...(variant === "outlined" && {
        border: `0.5px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        background: "transparent",
        "&:hover": {
            // transform: "translateY(-3px)",
            // background: `${theme.palette.primary.light}`,
            // borderColor: theme.palette.primary.main,
            // color:'#FFFFFF',
            background: `linear-gradient(135deg, ${theme.palette.primary.main}, #00a0ff)`,
        color: "#FFFFFF",
        boxShadow: "0 8px 20px rgba(10, 118, 250, 0.3)",
        },
        "&:active": {
            background: theme.palette.primary.main,
            color: "#FFFFFF",
        },
    }),
    
    [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(0.8), // Adjust padding for smaller screens
        fontSize: "1rem",
        borderRadius: 12,
    },
}));

export default DeedButtons;